module.exports = __webpack_public_path__ + "resources/label_small_group_owner.07f88388832e4dbd.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/label/img/label_small_group_owner.png
// module id = 562
// module chunks = 0 1 2 3